import { render, staticRenderFns } from "./addParkingSpace.vue?vue&type=template&id=2b05ecca"
import script from "./addParkingSpace.vue?vue&type=script&lang=js"
export * from "./addParkingSpace.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports